import { call, put, takeLatest } from "redux-saga/effects";
import { getNewAccessToken } from "../../Domain/api";
import { setAccessToken } from "../App/action";
import { GET_NEW_TOKEN } from "../App/constants";

export function* doReauthenticate({refreshToken, cbFailed}) {
    try {
        const result = yield call(getNewAccessToken, {refreshToken});
        yield put(setAccessToken(result.accessToken))
        window.location.reload();
    } catch (error) {
        cbFailed && cbFailed();
    }
}


export default function* clientSaga() {
    yield takeLatest(GET_NEW_TOKEN, doReauthenticate);
}